import { Fragment } from 'react'
import { Text, Link } from '@chakra-ui/react'

import { TermsAndPrivacyIndex, TermOrPrivacy } from '../types'

const ContactingUs = (
  <Fragment>
    <Text>
      หากคุณต้องการสอบถามข้อมูลเกี่ยวกับนโยบายความเป็นส่วนตัวฉบับนี้
      รวมถึงการขอใช้สิทธิต่าง ๆ
      คุณสามารถติดต่อเราหรือเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของเราได้ ดังนี้
    </Text>
    <Text>
      <Text as="strong" sx={{ fontSize: '20px' }}>
        บริษัท เดต้า ว้าว จำกัด
      </Text>
      <br />
      1778 อาคาร Summer Hub Offices ชั้นที่ 6 ถนนสุขุมวิท แขวงพระโขนง เขตคลองเตย
      กรุงเทพมหานคร
      <br />
      <br />
      อีเมล: <Link href="mailto:dpo@datawow.io">dpo@datawow.io </Link>
      <br />
      เว็บไซต์:{' '}
      <Link isExternal href="https://datawow.io/">
        www.datawow.io
      </Link>
      <br />
      โทรศัพท์: <Link href="tel:020245560">02-024-5560</Link>
    </Text>
  </Fragment>
)

export const termsAndPrivacyIndexes: Record<
  TermOrPrivacy,
  TermsAndPrivacyIndex
> = {
  terms: {
    title: 'ข้อกำหนดและเงื่อนไขในการใช้งาน',
    linkTo: '/terms-of-use',
    subMenus: [
      {
        title: 'บัญชี',
        scrollTo: 'terms-accounts-and-membership',
        content: (
          <Text>
            หากผู้ใช้ได้ทำการสร้างบัญชีผู้ใช้บนเว็บไซต์ของเรา
            คุณมีหน้าที่ในการรักษาความปลอดภัยของบัญชีของคุณและคุณต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้การใช้บัญชีหรือการดำเนินการอื่นใดที่เกี่ยวข้องกับบัญชีนั้น
            โดยเราไม่มีหน้าที่ในการดูแลและตรวจสอบบัญชีใหม่ก่อนที่คุณจะลงชื่อเข้าใช้และใช้บริการของเรา
            การให้ข้อมูลติดต่อที่เป็นเท็จไม่ว่าประเภทใดก็ตามอาจส่งผลให้บัญชีของคุณถูกยุติการใช้งาน
            นอกจากนี้
            คุณต้องแจ้งให้เราทราบทันทีเมื่อบัญชีของคุณถูกนำไปใช้โดยไม่ได้รับอนุญาตหรือการละเมิดความปลอดภัยอื่น
            ๆ ทางเราจะไม่รับผิดชอบต่อความเสียหายใด ๆ
            ที่เกิดขึ้นจากการกระทำหรือการละเว้นใด ๆ ของคุณ เราอาจระงับ
            ปิดการใช้งานหรือลบบัญชีของคุณ (หรืออย่างใดอย่างหนึ่ง)
            หากเราพิจารณาว่าคุณได้ละเมิดข้อกำหนดใด ๆ
            ของข้อตกลงนี้หรือการกระทำของคุณมีแนวโน้มที่จะทำลายชื่อเสียงและค่าความนิยมของเรา
            หากเราลบบัญชีของคุณด้วยเหตุผลข้างต้น
            คุณจะไม่สามารถลงทะเบียนใหม่เพื่อใช้บริการของเราได้
            โดยเราอาจบล็อกที่อยู่อีเมลและที่อยู่อินเทอร์เน็ตโปรโตคอลของคุณเพื่อป้องกันการลงทะเบียนอีกครั้ง
          </Text>
        ),
      },
      {
        title: 'ข้อมูลส่วนบุคคล',
        scrollTo: 'terms-personal-information',
        content: (
          <Text>
            บริษัทจะเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลของคุณที่ได้ให้แก่บริษัทด้วยความระมัดระวัง
            และเป็นไปตามมาตรฐานที่กำหนดภายใต้ “นโยบายความเป็นส่วนตัว” ของบริษัท
            ซึ่งถือเป็นส่วนหนึ่งของข้อกำหนดและเงื่อนไขการให้บริการฉบับนี้
          </Text>
        ),
      },
      {
        title: 'เนื้อหาของผู้ใช้งาน',
        scrollTo: 'terms-user-content',
        content: (
          <Text>
            เราไม่ได้เป็นเจ้าของข้อมูล ข่าวสาร หรือเนื้อหาใด ๆ (“เนื้อหา”)
            ที่คุณส่งให้กับบริการของเราในระหว่างการใช้บริการ
            คุณจะต้องรับผิดชอบต่อความถูกต้อง คุณภาพ ความสมบูรณ์
            ความถูกต้องตามกฎหมาย ความน่าเชื่อถือ
            ความเหมาะสมและความเป็นเจ้าของทรัพย์สินทางปัญญาหรือสิทธิในการใช้เนื้อหาที่ส่งทั้งหมดแต่เพียงผู้เดียว
            เราอาจดูแลและตรวจสอบเนื้อหาบนเว็บไซต์ที่คุณส่งให้กับการบริการของเรา
            หรือสร้างขึ้นโดยใช้บริการของเรา โดยการใช้งานเว็บไซต์ของคุณ
            ไม่ถือเป็นการให้อนุญาตแก่เราในการใช้ ทำซ้ำ ดัดแปลง แก้ไข เผยแพร่
            หรือแจกจ่ายเนื้อหาที่คุณสร้างขึ้นหรือจัดเก็บไว้ในบัญชีผู้ใช้ของคุณเพื่อการค้าการตลาดหรือวัตถุประสงค์อื่นใดที่คล้ายคลึงกัน
            เว้นแต่คุณจะให้การอนุญาตแก่เราเป็นการเฉพาะ อย่างไรก็ตาม
            คุณให้สิทธิแก่เราในการเข้าถึง คัดลอก แจกจ่าย จัดเก็บ ส่ง
            จัดรูปแบบและแสดงเนื้อหาของบัญชีผู้ใช้ของคุณตามที่กำหนดไว้สำหรับวัตถุประสงค์ในการให้บริการแก่คุณเท่านั้น
            เราขอสงวนสิทธิในการปฏิเสธหรือลบเนื้อหาใด ๆ ที่ละเมิดนโยบายของเรา
            ไม่เหมาะสม
            หรือเป็นอันตรายในทางใดทางหนึ่งต่อข้อกำหนดและเงื่อนไขตามดุลยพินิจของเรา
          </Text>
        ),
      },
      {
        title: 'การชำระเงิน',
        scrollTo: 'terms-billing-and-payments',
        content: (
          <Fragment>
            <Text>
              คุณจะต้องชำระค่าธรรมเนียมเมื่อถึงครบกำหนดชำระ
              ในกรณีที่มีการนำเสนอบริการแบบทดลองใช้ฟรี
              คุณอาจต้องชำระเงินหลังจากที่ช่วงทดลองใช้ฟรีสิ้นสุดลง
              ไม่ใช่เมื่อคุณใส่รายละเอียดในการเรียกเก็บเงินของคุณ
              (ซึ่งอาจจำเป็นต้องใส่ก่อนที่จะเริ่มช่วงทดลองใช้ฟรี)
              หากบริการที่คุณสมัครไว้มีการเปิดใช้งานต่อหลังจากหมดระยะทดลองใช้ฟรี
              คุณจะถูกเรียกเก็บเงินโดยอัตโนมัติตามเงื่อนไขที่คุณเลือก
              หากเรามีความเห็นว่า
              การทำธุรกรรมของคุณถือเป็นการทำธุรกรรมที่มีความเสี่ยงสูง
              เราจะขอให้คุณส่งสำเนาบัตรที่มีรูปถ่ายของเจ้าของบัตรซึ่งออกโดยหน่วยงานราชการหรือสำเนาใบแจ้งยอดบัญชีธนาคารล่าสุดสำหรับบัตรเครดิตหรือบัตรเดบิตที่ใช้สำหรับการซื้อในครั้งนั้น
              ๆ ไป
            </Text>
            <Text>
              เราขอสงวนสิทธิในการเปลี่ยนแปลงสินค้าหรือบริการและราคาสินค้าหรืบริการได้ตลอดเวลา
              และเราขอสงวนสิทธิในการปฏิเสธคำสั่งซื้อใด ๆ ที่คุณสั่งซื้อกับเรา
              โดยเราอาจจำกัดคำสั่งซื้อตามดุลยพินิจของเรา
            </Text>
            <Text>
              ข้อจำกัดเหล่านี้อาจรวมไปถึงคำสั่งซื้อที่ดำเนินการซื้อโดยหรือภายใต้บัญชีลูกค้าเดียวกัน
              บัตรเครดิตเดียวกันและ/
              หรือคำสั่งซื้อที่ใช้การเรียกชำระค่าธรรมเนียม
              ในกรณีที่เราทำการเปลี่ยนแปลงหรือยกเลิกคำสั่งซื้อ
              เราจะพยายามแจ้งให้คุณทราบโดยติดต่อไปทางอีเมลและ /
              หรือที่อยู่สำหรับการเรียกชำระค่าธรรมเนียม
              หรือหมายเลขโทรศัพท์ที่คุณได้ให้ไว้ในขณะที่ทำการสั่งซื้อ
            </Text>
            <Text>
              LearnPDPA ขอนำเสนอสินค้าและบริการเพื่อการจำหน่าย
              เมื่อเราได้รับคำสั่งซื้อและการชำระค่าธรรมเนียมของคุณ
              และการชำระค่าธรรมเนียมนั้นได้ผ่านการตรวจสอบการฉ้อโกงเรียบร้อยแล้ว
              เราจะให้สิทธิในการเข้าถึงผลิตภัณฑ์หรือบริการที่ซื้อแก่คุณโดยเร็วที่สุดโดยค่าธรรมเนียมทั้งหมดทางเราขอสงวนสิทธิไม่คืนค่าธรรมเนียมแก่คุณ
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'นโยบายการคืนเงิน',
        scrollTo: 'refund-policy',
        content: (
          <Text>
            เนื่องจากบริการของเรานำเสนอสินค้าที่จับต้องไม่ได้และไม่สามารถเพิกถอนหลังจากที่เราได้ให้สิทธิการเข้าถึงแก่คุณไปแล้ว
            เราจึงขอสงวนสิทธิในการคืนเงินให้กับคุณหลังจากซื้อผลิตภัณฑ์
            ซึ่งคุณรับทราบก่อนที่จะซื้อผลิตภัณฑ์และบริการใด ๆ บนเว็บไซต์
            โปรดอ่านรายละเอียดการบริการอย่างละเอียดก่อนตัดสินใจซื้อบริการของเรา
          </Text>
        ),
      },
      {
        title: 'ความถูกต้องและสมบูรณ์ของข้อมูล',
        scrollTo: 'terms-accuracy-of-information',
        content: (
          <Text>
            ในบางโอกาส ข้อมูลบนเว็บไซต์อาจมีข้อผิดพลาด เช่น มีการสะกดผิด
            ความไม่ถูกต้องของข้อมูล
            หรือการละเว้นในบางจุดที่อาจมีความเกี่ยวข้องไปถึงโปรโมชั่นและข้อเสนอ
            เราขอสงวนสิทธิ์ในการแก้ไขข้อผิดพลาด ความไม่ถูกต้องหรือการละเว้นใด ๆ
            เพื่อการเปลี่ยนแปลง อัปเดตข้อมูลหรือยกเลิกคำสั่งซื้อ หากข้อมูลใด ๆ
            บนเว็บไซต์หรือบริการที่เกี่ยวข้องมีความไม่ถูกต้องเมื่อใดก็ได้โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            (รวมถึงหลังจากที่คุณส่งคำสั่งซื้อแล้ว)
          </Text>
        ),
      },
      {
        title: 'ลิงค์ของบุคคลที่สาม',
        scrollTo: 'terms-links-to-other-websites',
        content: (
          <Text>
            แพลตฟอร์มของบริษัทอาจประกอบด้วยลิงค์เพื่อใช้เชื่อมต่อไปยังแพลตฟอร์มของบุคคลที่สามซึ่งบริษัทไม่ได้มีอำนาจควบคุมแต่อย่างใด
            การใช้งานของคุณบนแพลตฟอร์มของบุคคลที่สามถือเป็นข้อตกลงระหว่างคุณกับบุคคลที่สามเองโดยบริษัทไม่มีหน้าที่
            และ/หรือความรับผิดใด ๆ ต่อเนื้อหา
            รวมถึงการใช้งานของคุณบนแพลตฟอร์มนั้น
            คุณเป็นผู้รับความเสี่ยงที่อาจเกิดขึ้นทั้งหมด
          </Text>
        ),
      },
      {
        title: 'ข้อจำกัดเกี่ยวกับการใช้งาน',
        scrollTo: 'terms-prohibited-uses',
        content: (
          <Fragment>
            <Text>
              คุณตกลงใช้บริการของบริษัทเพื่อวัตถุประสงค์ที่ชอบด้วยกฎหมาย
              และจะไม่กระทำการอย่างหนึ่งอย่างใดดังต่อไปนี้
            </Text>
            <ol>
              <li>
                กระทำการใด ๆ ที่ฝ่าฝืนต่อสัญญา กฎหมาย ข้อบังคับ หรือระเบียบใด ๆ
                ภายในประเทศ
              </li>
              <li>
                ชักชวนหรือสนับสนุนผู้อื่นให้ดำเนินการหรือมีส่วนร่วมในการกระทำที่ผิดกฎหมาย
              </li>
              <li>
                ละเมิดกฎระเบียบ ข้อบังคับ
                กฎหมายหรือข้อบัญญัติท้องถิ่นระหว่างประเทศ รัฐบาลกลาง
                จังหวัดหรือรัฐ
              </li>
              <li>
                พสต์ หรือเผยแพร่ข้อความใด ๆ
                ที่มีเนื้อหาที่แสดงออกถึงความรุนแรงคุกคาม ลามก
                หรือมีเนื้อหาทางเพศ หรือเลือกปฏิบัติทางเชื้อชาติ ชาติกำเนิด
                สัญชาติศาสนา เพศ สถานภาพทางสังคมหรือมีเนื้อหาเป็นภัยต่อสังคม
                หรือทำให้ผู้อื่นเกิดความเดือดร้อนรำคาญตลอดจนเผยแพร่เนื้อหาใดที่เป็นอันตรายต่อบุคคลอื่น
                และ/หรือทำให้บุคคลอื่นเสียหาย เช่นเนื้อหาที่เป็นอันตรายต่อเด็ก
                หรือละเมิดสิทธิความเป็นส่วนตัวของบุคคลอื่น
              </li>
              <li>
                กระทำการละเมิดสิทธิในทรัพย์สินทางปัญญาใด ๆ
                ของบริษัทหรือสิทธิในทรัพย์สินทางปัญญาของผู้อื่นซึ่งรวมถึงการทำซ้ำ
                คัดลอก ดัดแปลง ขายต่อ
                หรือใช้ประโยชน์อื่นใดจากส่วนใดส่วนหนึ่งหรือทั้งหมดของแพลตฟอร์มของบริษัทหรือผลงานของบุคคลอื่นโดยไม่ได้รับอนุญาต
              </li>
              <li>
                จำหน่าย ให้เช่า ให้ยืม
                อนุญาตให้ใช้หรือให้สิทธิในบัญชีผู้ใช้งานของคุณแก่บุคคลอื่นไม่ว่าจะด้วยเหตุใดก็ตาม
              </li>
              <li>
                สร้างลิงค์ใด ๆ มายังแพลตฟอร์มของบริษัทหรือกระทำการใด ๆ
                ที่ทำให้บุคคลภายนอกเชื่อได้ว่ามีความร่วมมือ การอนุมัติ
                หรือการสนับสนุนจากบริษัทซึ่งไม่เป็นความจริง
              </li>
              <li>
                บิดเบือนข้อมูล ทำให้เกิดความเข้าใจผิดเสื่อมเสียชื่อเสียง
                หรือเผยแพร่ข้อมูลเท็จโดยเจตนา
              </li>
              <li>
                เพื่ออัปโหลดหรือส่งไวรัสหรือรหัสที่เป็นอันตรายประเภทอื่นที่จะหรืออาจใช้ในลักษณะใด
                ๆ
                ที่จะส่งผลกระทบต่อการทำงานหรือการทำงานของบริการหรือเว็บไซต์ที่เกี่ยวข้องเว็บไซต์อื่นหรืออินเทอร์เน็ต
              </li>
              <li>
                จัดทำผลิตภัณฑ์หรือบริการที่มีลักษณะเป็นการแข่งขันกับบริษัทและ/หรือคัดลอกเนื้อหา
                แนวคิด ฟีเจอร์การทำงาน กราฟฟิค หรือผลงานใด ๆ
                บนแพลตฟอร์มของบริษัทไม่ว่าด้วยวิธีใดก็ตาม
              </li>
              <li>
                เพื่อสแปม ใช้อีเมลหรือหน้าเว็บไซต์ปลอม
                โปรแกรมที่ถูกออกแบบขึ้นเพื่อการค้นหาในอินเตอร์เน็ต
                หรือเทคโนโลยีอื่น ๆ
                เพื่อให้ได้มาซึ่งข้อมูลของผู้อื่นโดยไม่ได้รับอนุญาต
              </li>
              <li>
                กระทำการใด ๆ
                ซึ่งทำให้บริษัทอาจมีส่วนเกี่ยวข้องในข้อพิพาทหรือข้อเรียกร้องหรือกระทำการอื่นใดที่บริษัท
                พิจารณาแล้วว่าไม่เหมาะสม ทำให้บริษัทเสื่อมเสียชื่อเสียง
                และ/หรือได้รับความเสียหาย
              </li>
              <li>
                เพื่อแทรกแซงหรือหลีกเลี่ยงคุณลักษณะทางด้านความปลอดภัยของบริการหรือเว็บไซต์ที่เกี่ยวข้องเว็บไซต์อื่น
                ๆ
              </li>
            </ol>
            <Text>
              บริษัทมีสิทธิ (แต่ไม่มีภาระผูกพัน)
              ในการตรวจสอบว่าคุณปฏิบัติตามข้อกำหนดและเงื่อนไขฉบับนี้
              ตลอดจนกฎหมายที่เกี่ยวข้อง
              หากบริษัทพบว่าหรือมีเหตุอันควรเชื่อได้ว่าคุณกระทำการฝ่าฝืนใด ๆ
              บริษัทมีสิทธิใช้ดุลพินิจแต่ฝ่ายเดียวที่จะลบเนื้อหาที่ฝ่าฝืนดังกล่าวและ/หรือระงับการใช้บริการของคุณไม่ว่าโดยชั่วคราวหรือถาวรโดยไม่ต้องบอกกล่าวล่วงหน้าและ/หรืออาจดำเนินการทางกฎหมายกับคุณตามที่บริษัทเห็นสมควรได้ทันที
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'สิทธิในทรัพย์สินทางปัญญา',
        scrollTo: 'terms-intellectual-property-rights',
        content: (
          <Text>
            ข้อตกลงนี้จะไม่ใช่การโอนสิทธิในทรัพย์สินทางปัญญาใด ๆ ที่เป็นของ
            บริษัท ดาต้าว้าว จำกัด หรือบุคคลที่สาม โดย
            สิทธิกรรมสิทธิและผลประโยชน์ทั้งหมดของทรัพย์สินดังกล่าวจะยังคงอยู่
            (ในระหว่างคู่สัญญา) กับ บริษัท เดต้า ว้าว จำกัด แต่เพียงผู้เดียว
            เครื่องหมายทางการค้า เครื่องหมายบริการ กราฟิก โลโก้ ข้อความ เนื้อหา
            ซอฟต์แวร์วิดีโอ ดนตรี เสียง กราฟฟิก รูปภาพ งานแสดง งานศิลปะ ภาพวาด{' '}
            หรือส่วนประกอบใด ๆ ทั้งหมดบนแพลตฟอร์ม (เรียกรวมกันว่า “เนื้อหา”)
            ที่ถูกใช้ร่วมกับเว็บไซต์หรือบริการของเรา
            ถือเป็นเครื่องหมายทางการค้าหรือเครื่องหมายทางการค้าจดทะเบียนของ
            LearnPDPA และ บริษัท เดต้า ว้าว จำกัด หรือผู้อนุญาตให้สิทธิแก่เรา
            นอกจากนี้ เครื่องหมายการค้า เครื่องหมายการบริการ กราฟิกและโลโก้
            และเนื้อหาอื่น ๆ
            ที่ใช้ร่วมกับเว็บไซต์หรือบริการของเราอาจเป็นเครื่องหมายการค้าของบุคคลที่สามอื่น
            ๆ
            ดังนั้นในการเข้าใช้เว็บไซต์และบริการของเราไม่ได้ถือว่าเราให้สิทธิหรือใบอนุญาตแก่คุณในการทำซ้ำ
            คัดลอก ลอกเลียน ดัดแปลง ทำวิศวกรรมย้อนหลัง ปลอมแปลงจัดเผยแพร่
            จำหน่าย ให้เช่า เข้าครอบครอง เรียกดึงข้อมูล บันทึก ส่งผ่าน
            หรือกระทำการใด ๆ
            เกี่ยวกับเนื้อหาดังกล่าวโดยไม่ชอบด้วยกฎหมายหรือโดยไม่ได้รับอนุญาตจากเราหรือผู้อนุญาตให้ใช้สิทธิของบริษัทก่อนโดยเด็ดขาด
          </Text>
        ),
      },
      {
        title: 'ข้อจำกัดความรับผิดชอบในการรับประกัน',
        scrollTo: 'terms-disclaimer-of-warranty',
        content: (
          <Text>
            คุณยอมรับว่าการใช้เว็บไซต์หรือบริการของเรานั้นถือเป็นความเสี่ยงของคุณเองแต่เพียงผู้เดียว
            คุณยอมรับว่าบริการดังกล่าวมีให้ตามเกณฑ์ &quot;ตามสภาพ&quot; และ
            &quot;ตามที่มีอยู่&quot; เราขอปฏิเสธการรับประกันใด ๆ
            โดยชัดแจ้งหรือโดยนัย
            รวมถึงแต่ไม่จำกัดเพียงการรับประกันโดยนัยเกี่ยวกับความสามารถทางการค้า
            ความเหมาะสมสำหรับวัตถุประสงค์ใดโดยเฉพาะ และการไม่ละเมิดสิทธิ
            เราไม่รับประกันว่าบริการของเราจะตรงตามความต้องการของคุณหรือว่าการบริการจะไม่หยุดชะงัก
            ไม่ล่าช้า ปลอดภัยหรือปราศจากข้อผิดพลาด นอกจากนี้เรายังไม่รับประกันใด
            ๆ เกี่ยวกับผลลัพธ์ที่อาจได้รับจากการใช้บริการ
            ความถูกต้องหรือความน่าเชื่อถือของข้อมูลใด ๆ
            ที่ได้รับผ่านการบริการหรือข้อบกพร่องในบริการจะได้รับการแก้ไข
            คุณเข้าใจและยอมรับว่าเนื้อหาและ/ หรือข้อมูลใด ๆ
            ที่ดาวน์โหลดหรือได้รับจากการใช้บริการ
            จะกระทำขึ้นอยู่กับดุลยพินิจและความเสี่ยงของคุณเองและคุณจะต้องรับผิดชอบแต่เพียงผู้เดียวต่อความเสียหายใด
            ๆ
            ที่เกิดขึ้นกับระบบคอมพิวเตอร์ของคุณหรือการสูญเสียข้อมูลอันเป็นผลมาจาก
            ดาวน์โหลดเนื้อหาและ/ หรือข้อมูลดังกล่าว
            เราไม่รับประกันสินค้าหรือบริการใด ๆ
            ที่คุณซื้อหรือได้รับผ่านบริการหรือธุรกรรมใด ๆ ที่ทำผ่านการบริการ
          </Text>
        ),
      },
      {
        title: 'ข้อจำกัดความรับผิด',
        scrollTo: 'terms-limitation-of-liability',
        content: (
          <Text>
            ตามขอบเขตสูงสุดที่กฎหมายที่บังคับใช้ให้อนุญาต ไม่ว่าในกรณีใดก็ตาม
            บริษัท บริษัทในเครือ เจ้าหน้าที่ กรรมการพนักงาน ตัวแทน ซัพพลายเออร์
            หรือผู้ได้รับอนุญาตของบริษัท จะไม่รับผิดชอบต่อบุคคลใด ๆ สำหรับ
            ความเสียหายโดยตรง ความเสียหายโดยอ้อม ความเสียหายที่เป็นผลสืบเนื่อง
            ค่าเสียหายที่เป็นเยี่ยงอย่าง ความเสียหายโดยบังเอิญ
            หรือค่าเสียหายเชิงลงโทษ (รวมถึงแต่ไม่จำกัดเพียง ความเสียหายจากผลกำไร
            รายได้ การขาย ไวรัสคอมพิวเตอร์ ค่าความนิยม การใช้เนื้อหา
            ผลกระทบต่อธุรกิจ ความล่าช้า การถูกรบกวน การล่มของระบบ
            การหยุดชะงักของธุรกิจ การสูญเสียเงินออมที่คาดการณ์ไว้
            การสูญเสียโอกาสทางธุรกิจ หรือเหตุสุดวิสัยต่าง ๆ
            ซึ่งอยู่นอกเหนือความควบคุมของเรา) หรือความเสียหายอื่นใด
            อันเกิดจากการรับรอง สัญญา การละเมิด การรับประกัน
            การไม่ปฏิบัติหน้าที่ตามกฎหมาย ความประมาทเลินเล่อ หรืออื่น ๆ แม้ว่า
            เราจะได้รับการแจ้งเตือน คำแนะนำเกี่ยวกับความเป็นไปได้ในการ
            เกิดเหตุการณ์เหล่านั้นจากการใช้บริการแพลตฟอร์มของคุณแล้วก็ตาม
          </Text>
        ),
      },
      {
        title: 'การชดใช้ค่าเสียหาย',
        scrollTo: 'terms-indemnification',
        content: (
          <Text>
            คุณตกลงที่จะชดใช้ค่าเสียหายและปกป้อง บริษัท เดต้าว้าว จำกัด และ
            บริษัทในเครือ กรรมการ เจ้าหน้าที่
            พนักงานและตัวแทนที่เกิดขึ้นเกี่ยวกับหรือเกิดขึ้น จากข้อเรียกร้อง
            ความสูญเสีย ความรับผิด การเรียกร้องสิทธิ หรือค่าใช้จ่าย
            (รวมถึงค่าทนายความ)จากข้อกล่าวหาของบุคคลที่สามเรียกร้อง
            ดำเนินการข้อพิพาทหรือข้อเรียกร้องใด ๆ
            ที่ถูกกล่าวหาว่าเป็นผลมาจากหรือเกี่ยวข้องกับเนื้อหาการใช้งานเว็บไซต์หรือบริการของคุณ
            หรือการประพฤติมิชอบโดยเจตนาใด ๆ ในส่วนของคุณ
          </Text>
        ),
      },
      {
        title: 'การแยกข้อสัญญาส่วนที่เป็นโมฆะออกจากส่วนที่ไม่เป็นโมฆะ',
        scrollTo: 'terms-severability',
        content: (
          <Text>
            สิทธิและข้อจำกัดทั้งหมดที่มีอยู่ในข้อตกลงนี้อาจถูกใช้
            มีผลบังคับใช้และมีผลผูกพัน
            เฉพาะในขอบเขตที่ข้อจำกัดนั้นไม่ละเมิดกฎหมายที่เกี่ยวข้องใด ๆ
            และตั้งใจที่จะจำกัดในขอบเขตที่จำเป็นเพื่อที่จะไม่ทำให้ข้อตกลงนี้ผิดกฎหมาย
            ไม่ถูกต้อง หรือไม่สามารถบังคับใช้ได้
            หากข้อกำหนดหรือส่วนใดส่วนหนึ่งของข้อกำหนดใด ๆ
            ของข้อตกลงนี้จะถือว่าผิดกฎหมายไม่ถูกต้องหรือไม่สามารถบังคับใช้ได้โดยศาลที่มีอำนาจ
            คู่สัญญาตกลงว่าบทบัญญัติหรือส่วนที่เหลือจะถือเป็นข้อตกลงที่ยังคงมีผลบังคับใช้อย่างสมบูรณ์
          </Text>
        ),
      },
      {
        title: 'การเปลี่ยนแปลงและการแก้ไข',
        scrollTo: 'terms-changes-amendments',
        content: (
          <Text>
            คุณตกลงที่จะชดใช้ค่าเสียหายและปกป้อง บริษัท เดต้าว้าว จำกัด และ
            บริษัทในเครือ กรรมการ เจ้าหน้าที่
            พนักงานและตัวแทนที่เกิดขึ้นเกี่ยวกับหรือเกิดขึ้น จากข้อเรียกร้อง
            ความสูญเสีย ความรับผิด การเรียกร้องสิทธิ์ หรือค่าใช้จ่าย
            (รวมถึงค่าทนายความ) จากข้อกล่าวหาของบุคคลที่สามเรียกร้อง
            ดำเนินการข้อพิพาทหรือข้อเรียกร้องใด ๆ
            ที่ถูกกล่าวหาว่าเป็นผลมาจากหรือเกี่ยวข้องกับเนื้อหาการใช้งานเว็บไซต์หรือบริการของคุณ
            หรือการประพฤติมิชอบโดยเจตนาใด ๆ ในส่วนของคุณ
          </Text>
        ),
      },
      {
        title: 'กฎหมายที่ใช้บังคับ',
        scrollTo: 'terms-acceptance-of-these-terms',
        content: (
          <Text>
            ข้อกำหนดและเงื่อนไขฉบับนี้อยู่ภายใต้บังคับของกฎหมายแห่งราชอาณาจักรไทย
            บรรดาข้อพิพาททั้งหมดที่เกิดขึ้นจากการใช้แพลตฟอร์มให้อยู่ภายใต้เขตอำนาจของศาลในราชอาณาจักรไทยเท่านั้น
          </Text>
        ),
      },
      {
        title: 'รายละเอียดการติดต่อ',
        scrollTo: 'terms-contacting-us',
        content: ContactingUs,
      },
    ],
  },
  privacy: {
    title: 'นโยบายความเป็นส่วนตัว',
    linkTo: '/privacy-policy',
    subMenus: [
      {
        title: 'การเก็บรวบรวมข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-collection-of-information',
        content: (
          <Fragment>
            <Text>
              เราจะเก็บรวบรวมข้อมูลส่วนบุคคลที่ได้รับโดยตรงจากคุณผ่านช่องทาง
              ดังต่อไปนี้
              การลงทะเบียนและการสมัครบัญชีผู้ใช้งานผ่านทางเว็บไซต์บริษัท
              การทำแบบสอบถามความสนใจ การติดต่อผ่านโทรศัพท์ อีเมล เป็นต้น
            </Text>
            <Text>
              เราอาจเก็บรวบรวมข้อมูลส่วนบุคคลของคุณที่เราเข้าถึงได้จากแหล่งอื่น
              เช่น โซเชียลมีเดีย หน่วยงานราชการ บุคคลภายนอกอื่น ๆ เป็นต้น
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'ประเภทข้อมูลส่วนบุคคลที่เก็บรวบรวม',
        scrollTo: 'privacy-collection-of-personal-information',
        content: (
          <Fragment>
            <Text>
              ผู้เยี่ยมชมทุกคนสามารถเข้าถึงเนื้อหาที่เผยแพร่บนเว็บไซต์ของเราได้
              อย่างไรก็ตามคุณลักษณะและบริการบางอย่างอาจต้องมีการลงทะเบียน
              ผู้ใช้สามารถลงทะเบียน (“สมัครใช้งาน”) ได้ที่หน้าเว็บไซต์
              โดยคุณสามารถเพิ่มสิทธิการเข้าถึงบริการอื่น ๆ
              ได้โดยการทำตามกระบวนการที่เหมาะสม เช่น
              การชำระเงินเพื่อเข้าถึงเนื้อหาและบริการอื่น ๆ
              ตามเงื่อนไขที่ทางเรากำหนด ข้อมูลส่วนบุคคลที่เราเก็บรวบรวมจากคุณ
              ได้แก่ ข้อมูลใด ๆ
              ซึ่งสามารถใช้ในการระบุตัวตนของคุณได้ไม่ว่าโดยตรงหรือโดยอ้อม
              ซึ่งรวมถึงแต่ไม่จำกัดเพียงข้อมูลดังต่อไปนี้
            </Text>
            <ul>
              <li>
                ข้อมูลส่วนบุคคล เช่น ชื่อ นามสกุล อายุ วันเดือนปีเกิด
                เลขประจำตัวประชาชน/หนังสือเดินทาง
              </li>
              <li>ข้อมูลการติดต่อ เช่น ที่อยู่ หมายเลขโทรศัพท์ อีเมล </li>
              <li>ข้อมูลบัญชี เช่น บัญชีผู้ใช้งาน ประวัติการใช้งาน </li>
              <li>
                หลักฐานแสดงตัวตน เช่น สำเนาบัตรประจำตัวประชาชน
                สำเนาหนังสือเดินทาง
              </li>
              <li>
                ข้อมูลการทำธุระกรรมและการเงิน เช่น ประวัติการสั่งซื้อ
                รายละเอียดบัตรเครดิต บัญชีธนาคาร
              </li>
              <li>
                ข้อมูลอื่น ๆ เช่น รูปภาพ ภาพเคลื่อนไหว
                และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
              </li>
            </ul>
            <br />
            <Text>
              เราอาจเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลอ่อนไหว
              เมื่อเราได้รับความยินยอมโดยชัดแจ้งจากคุณ
              เว้นแต่กฎหมายกำหนดให้ทำได้ ได้แก่ ข้อมูลสุขภาพ ศาสนา ข้อมูลชีวภาพ
              เช่น ข้อมูลภาพจำลองใบหน้า ข้อมูลจำลองม่านตา ข้อมูลจำลองลายนิ้วมือ
              เป็นต้น
              รวมถึงข้อมูลอื่นใดที่กระทบต่อข้อมูลส่วนบุคคลของคุณตามที่คณะกรรมการคุ้มครองข้อมูลส่วนบุคคลประกาศกำหนด
            </Text>
            <Text>
              โดยเราจะได้รับข้อมูลเหล่านี้เมื่อคุณลงทะเบียน
              สมัครสมาชิกบนแพลตฟอร์ม เข้าร่วมกิจกรรม แคมเปญส่งเสริมการขาย
              หรือการสำรวจใด ๆ ที่บริษัทเป็นผู้จัดขึ้น
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'ข้อมูลที่ทางเราเก็บรวบรวมโดยอัตโนมัติ',
        scrollTo: 'privacy-automatically-collected-information',
        content: (
          <Fragment>
            <Text>
              ข้อมูลทางเทคนิค ซึ่งรวมถึงแต่ไม่จำกัดเพียง IP Address, Cookie ID,
              ประวัติการใช้งานเว็บไซต์ (Activity Log)
              และข้อมูลเกี่ยวกับการเยี่ยมชมของคุณ รายการของตัวระบุทรัพยากรสากล
              ทั้งหมดที่เชื่อมมายังแพลตฟอร์ม ผ่านแพลตฟอร์ม และจากแพลตฟอร์มของเรา
              (รวมถึงวันที่และเวลา) ผลิตภัณฑ์ที่คุณกำลังดูหรือมองหา
              เวลาตอบสนองของหน้าเพจ ปัญหาการดาวน์โหลด
              ระยะเวลาที่เยี่ยมชมแต่ละหน้าเพจ
              และข้อมูลในการเข้าใช้แพลตฟอร์มของคุณ
            </Text>
            <Text>
              เราจะได้รับข้อมูลเหล่านี้เมื่อคุณเข้าเยี่ยมชมเว็บไซต์ของเรา
              เซิร์ฟเวอร์ของเราจะบันทึกข้อมูลที่เบราว์เซอร์ของคุณส่งโดยอัตโนมัติ
            </Text>
            <Text>
              ข้อมูลเหล่านี้ที่ถูกรวบรวมโดยอัตโนมัติจะใช้เพื่อระบุกรณีการละเมิดที่อาจเกิดขึ้นและสร้างข้อมูลทางสถิติเกี่ยวกับการใช้งานเว็บไซต์ของเรา
              โดยข้อมูลทางสถิตินี้จะไม่ถูกรวบรวมในลักษณะที่จะระบุผู้ใช้รายใดรายหนึ่งของระบบ
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'ผู้เยาว์',
        scrollTo: 'privacy-minor',
        content: (
          <Text>
            หากคุณมีอายุต่ำกว่า 20 ปีหรือมีข้อจำกัดความสามารถตามกฎหมาย
            เราอาจเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ
            เราอาจจำเป็นต้องให้พ่อแม่หรือผู้ปกครองของคุณให้ความยินยอมหรือที่กฎหมายอนุญาตให้ทำได้
            หากเราทราบว่ามีการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้เยาว์โดยไม่ได้รับความยินยอมจากพ่อแม่หรือผู้ปกครอง
            เราจะดำเนินการลบข้อมูลนั้นออกจากเซิร์ฟเวอร์ของเรา
          </Text>
        ),
      },
      {
        title: 'การเก็บ รวบรวม และใช้ข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-use-and-processing-of-collected-information',
        content: (
          <Fragment>
            <Text>
              เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณตามคำขอ
              และ/หรือข้อตกลงที่คุณได้ทำไว้กับเรา
              ซึ่งรวมถึงแต่ไม่จำกัดเพียงวัตถุประสงค์ดังต่อไปนี้
            </Text>
            <ol>
              <li>
                เพื่อสร้างและจัดการบัญชีผู้ใช้งาน
                ยืนยันหรือระบุตัวตนของคุณในเวลาที่คุณเข้าใช้แพลตฟอร์มของเรา
                เพื่อการบริหารและจัดการภายในองค์กร
              </li>
              <li>
                เพื่อดำเนินการตามคำขอของคุณและพิจารณาอนุมัติเกี่ยวกับการให้บริการ
                รวมถึงส่งมอบผลิตภัณฑ์ และ/หรือบริการของเราแก่คุณ
              </li>
              <li>
                ป้องกันและตรวจสอบการฉ้อโกงการละเมิดความปลอดภัยในกิจกรรมต่าง ๆ
                ที่อาจต้องผิดกฎหมายและข้อตกลงและเงื่อนไขการใช้งานของของเรา
              </li>
              <li>
                เพื่อบริหารจัดการ พัฒนา ปรับแต่ง ประเมิน
                และปรับปรุงเนื้อหาการให้บริการ และการโฆษณาของเรา
              </li>
              <li>
                เพื่อให้บริการด้านการจัดหาเนื้อหา ผลิตภัณฑ์
                รวมถึงการให้บริการอื่น ๆ ที่เกี่ยวข้อง รวมถึงให้ความช่วยเหลือ
                คำแนะนำแก่คุณในกรณีที่เกี่ยวข้องกับการเข้าใช้งานแพลตฟอร์ม
              </li>
              <li>เพื่อติดตามหรือบันทึกการใช้งานของคุณบนแพลตฟอร์ม</li>
              <li>
                เพื่อการตลาดและการส่งเสริมการขาย บริการหลังการขาย
                แจ้งการอัพเดทสื่อการสอน กิจกรรม ฟีเจอร์ใหม่บนแพลตฟอร์ม ข่าวสาร
                เพื่อประโยชน์ของคุณ
              </li>
              <li>
                เพื่อรวบรวมข้อเสนอแนะ ใช้ในการ วิจัย ประเมิน พัฒนา
                และปรับปรุงการให้บริการ ฟีเจอร์
                และเทคโนโลยีบนแพลตฟอร์มให้มีประสิทธิภาพและตอบสนองต่อความต้องการของผู้ใช้บริการมากยิ่งขึ้น
                เช่นการทดสอบ วิจัย จัดทำสถิติ
              </li>
              <li>
                เพื่อให้ผู้ให้บริการติดต่อคุณทางอีเมลหรือโทรศัพท์เพื่อแก้ไขปัญหาและการเรียกเก็บค่าธรรมเนียม
              </li>
              <li>
                เพื่อโพสต์หรือประชาสัมพันธ์ความพึงพอใจของท่านที่มีเกี่ยวกับผลิตภัณฑ์และบริการของเรา
              </li>
              <li>
                เพื่อเป็นการปฏิบัติตามนโยบายข้อตกลงและเงื่อนไขของเรา
                และเพื่อเป็นการปฏิบัติตามกฎหมายและกฎระเบียบของหน่วยงานราชการต่าง
                ๆ เช่น
                พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลพระราชบัญญัติว่าด้วยการกระทำความผิดเกี่ยวกับคอมพิวเตอร์
                พระราชบัญญัติการรักษาความมั่นคงปลอดภัยไซเบอร์ และกฎหมายอื่น ๆ
                ที่เราต้องปฏิบัติตาม
              </li>
            </ol>
            <Text>
              นอกจากนี้ ในกรณีเราได้เก็บ รวบรวม ใช้
              ข้อมูลส่วนบุคคลของคุณก่อนวันที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
              เรามีสิทธิในการเก็บรวบรวม ใช้
              และเปิดเผยข้อมูลส่วนบุคคลของคุณตามวัตถุประสงค์เดิมต่อไปโดยไม่ต้อง
              ขออนุญาตคุณอีกครั้ง อย่างไรก็ตาม
              หากคุณไม่ประสงค์ที่จะให้เราดำเนินการใด ๆ
              กับข้อมูลส่วนบุคคลดังกล่าวต่อไป
              คุณสามารถแจ้งเราเพื่อขอถอนความยินยอมของคุณเมื่อใดก็ได้
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'การเปิดเผยข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-disclosure',
        content: (
          <Fragment>
            <Text>
              เพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการฉ้อโกงและการทำธุรกรรมที่ไม่ได้รับอนุญาต
              (เช่นการฟอกเงิน) การฟ้องร้องและความรับผิดอื่น ๆ
              เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่ผู้อื่นภายใต้ความยินยอมของคุณหรือที่กฎหมายอนุญาตให้เปิดเผยได้
              โดยบุคคลภายนอกนั้นรวมถึง บริษัทในเครือ คู่ค้าของบริษัท
              และ/หรือบุคคลหรือนิติบุคคลอื่นใดที่บริษัทมีนิติสัมพันธ์ด้วย
              ไม่ว่าจะมีวัตถุประสงค์เพื่อการค้าหรือไม่ รวมถึงกรรมการ ผู้บริหาร
              พนักงาน ลูกจ้าง ผู้รับจ้าง ตัวแทน หรือที่ปรึกษาของบริษัท
              ซึ่งรวมถึงแต่ไม่จำกัดเพียงบุคคล/องค์กรดังต่อไปนี้
            </Text>
            <br />
            <Text>
              <Text as="strong">การบริหารจัดการภายในองค์กร</Text>
              <br />
              เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณภายในบริษัทเท่าที่จำเป็นเพื่อปรับปรุงและพัฒนาสินค้าหรือบริการของเรา
              เราอาจรวบรวมข้อมูลภายในสำหรับสินค้าหรือบริการต่าง ๆ
              ภายใต้นโยบายนี้เพื่อประโยชน์ของคุณและผู้อื่นมากขึ้น
            </Text>
            <Text>
              <Text as="strong">ผู้ให้บริการ</Text>
              <br />
              เราอาจเปิดเผยข้อมูลส่วนบุคคลของคุณบางอย่างให้กับผู้ให้บริการของเราเท่าที่จำเป็นเพื่อดำเนินงานในด้านต่าง
              ๆ เช่น การชำระเงิน การตลาด การพัฒนาสินค้าหรือบริการ เป็นต้น
              และผู้ให้บริการของเราไม่ได้รับอนุญาตให้ใช้หรือเปิดเผยข้อมูล
              ยกเว้นตามความจำเป็นเพื่อให้บริการในนามของเราหรือปฏิบัติตามข้อกำหนดทางกฎหมาย
              โดยเราไม่สามารถเข้าถึงข้อมูลการชำระเงินของคุณกับผู้ให้บริการของเราได้
              และข้อมูลนี้อยู่ภายใต้นโยบายความเป็นส่วนตัวของผู้ให้บริการ
              สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการชำระเงินที่ผู้ให้บริการของเรารวบรวมและวิธีการที่ผู้ให้บริการใช้ข้อมูลนี้
              โปรดดูนโยบายความเป็นส่วนตัวของตัวผู้ให้บริการ
            </Text>
            <Text>
              <Text as="strong">พันธมิตรทางธุรกิจ</Text>
              <br />
              เราอาจเปิดเผยข้อมูลบางอย่างกับพันธมิตรทางธุรกิจเพื่อติดต่อและประสานงานในการให้บริการสินค้าหรือบริการ
              และให้ข้อมูลเท่าที่จำเป็นเกี่ยวกับความพร้อมใช้งานของสินค้าหรือบริการ
            </Text>
            <Text>
              <Text as="strong">การถ่ายโอนธุรกิจ</Text>
              <br />
              เราอาจเปิดเผยข้อมูล รวมถึงข้อมูลส่วนบุคคลของคุณ
              สำหรับการปรับโครงสร้างองค์กร การควบรวมหรือการขายกิจการ
              หรือการถ่ายโอนสินทรัพย์อื่น ๆ
              บริษัทย่อมมีความจำเป็นที่จะต้องเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่บุคคลที่สามที่ได้รับการโอนหรือที่ประสงค์จะรับโอนสิทธิของดังกล่าวของเรา
              โดยฝ่ายที่รับโอนต้องปฏิบัติกับข้อมูลของคุณในลักษณะที่สอดคล้องกับนโยบายนี้
              รวมถึงกฎหมายคุ้มครองข้อมูลส่วนบุคคลด้วย
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'การส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศ',
        scrollTo: 'information-transfer',
        content: (
          <Fragment>
            <Text>
              เราอาจเปิดเผยหรือโอนข้อมูลส่วนบุคคลของคุณไปยังบุคคล องค์กร
              หรือบนระบบคลาวด์ของ Amazon Web Services (AWS) ณ ประเทศสิงคโปร์
              ทั้งนี้ เราจะดำเนินการตามมาตรการต่าง ๆ
              เพื่อให้มั่นใจว่าการโอนข้อมูลส่วนบุคคลของคุณไปยังประเทศปลายทางนั้นมีมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลอย่างเพียงพอ
              หรือกรณีอื่น ๆ ตามที่กฎหมายกำหนด เว้นแต่
            </Text>

            <ol>
              <li>เป็นการปฏิบัติตามกฎหมาย</li>
              <li>
                ได้รับความยินยอมจากคุณหลังจากได้ทำการแจ้งให้คุณทราบถึงมาตรฐานการคุ้มครองข้อมูลส่วนบุคคลที่ไม่เพียงพอของประเทศปลายทาง
              </li>
              <li>
                เป็นการปฏิบัติตามสัญญาที่คุณทำไว้กับเรา
                หรือตามคำขอของคุณก่อนการเข้าทำสัญญา
              </li>
              <li>
                เป็นการปฏิบัติตามสัญญาระหว่างเรากับบุคคล/นิติบุคคลอื่นเพื่อประโยชน์ของคุณ
              </li>
              <li>
                ป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
                หรือสุขภาพของคุณหรือของบุคคลอื่น
                เมื่อคุณไม่สามารถให้ความยินยอมในขณะนั้นได้
              </li>
            </ol>
          </Fragment>
        ),
      },
      {
        title: 'วิธีการเก็บรักษาข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-storage',
        content: (
          <Text>
            เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณในรูปแบบเอกสารและรูปแบบอิเล็กทรอนิกส์
            เราเก็บรักษาข้อมูลส่วนบุคคลของคุณบนเซิร์ฟเวอร์เราของเราในประเทศไทย
            และ บนระบบคลาวด์ของ Amazon Web Services (AWS) ณ ประเทศสิงคโปร์
          </Text>
        ),
      },
      {
        title: 'ระยะเวลาจัดเก็บข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-storage-period',
        content: (
          <Text>
            เราจะเก็บรักษาข้อมูลส่วนบุคคลของคุณไว้ตามระยะเวลาที่จำเป็นในระหว่างที่คุณเป็นลูกค้าหรือมีความสัมพันธ์อยู่กับเรา
            หรือ
            ตลอดระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ที่เกี่ยวข้องกับนโยบายฉบับนี้
            ซึ่งอาจจำเป็นต้องเก็บรักษาไว้ต่อไปภายหลังจากนั้น หากมีกฎหมายกำหนดไว้
            เราจะลบ ทำลาย หรือทำให้เป็นข้อมูลที่ไม่สามารถระบุตัวตนของคุณได้
            เมื่อหมดความจำเป็นหรือสิ้นสุดระยะเวลาดังกล่าว
          </Text>
        ),
      },
      {
        title: 'สิทธิเกี่ยวกับข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-the-rights-of-users',
        content: (
          <Fragment>
            <Text>
              เมื่อคุณให้ข้อมูลส่วนบุคคลกับเรา
              แล้วคุณมีสิทธิหลายประการซึ่งคุณสามารถดำเนินการใช้สิทธิได้โดยไม่เสียค่าใช้จ่ายภายใต้ข้อยกเว้นตามกฎหมาย
            </Text>
            <Text>
              สิทธิของคุณภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              คุณมีสิทธิในการดำเนินการ ดังต่อไปนี้
            </Text>
            <ol>
              <li>
                <Text as="strong">
                  สิทธิขอถอนความยินยอม (right to withdraw consent)
                </Text>{' '}
                หากคุณได้ให้ความยินยอม เราจะเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ
                ไม่ว่าจะเป็นความยินยอมที่คุณให้ไว้ก่อนวันที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลใช้บังคับหรือหลังจากนั้น
                คุณมีสิทธิที่จะถอนความยินยอมเมื่อใดก็ได้ตลอดเวลา
              </li>
              <li>
                <Text as="strong">สิทธิขอเข้าถึงข้อมูล (right to access)</Text>{' '}
                คุณมีสิทธิขอเข้าถึงข้อมูลส่วนบุคคลของคุณที่อยู่ในความรับผิดชอบของเรา
                และขอให้เราทำสำเนาข้อมูลดังกล่าวให้แก่คุณ
                รวมถึงขอให้เราเปิดเผยว่าเราได้ข้อมูลส่วนบุคคลของคุณมาได้อย่างไร
              </li>
              <li>
                <Text as="strong">
                  สิทธิขอถ่ายโอนข้อมูล (right to data portability)
                </Text>{' '}
                คุณมีสิทธิขอรับข้อมูลส่วนบุคคลของคุณในกรณีที่เราได้จัดทำข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบให้สามารถอ่านหรือใช้งานได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ
                รวมทั้งมีสิทธิขอให้เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นเมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติและมีสิทธิขอรับข้อมูลส่วนบุคคลที่เราส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่นโดยตรง
                เว้นแต่ไม่สามารถดำเนินการได้เพราะเหตุทางเทคนิค
              </li>
              <li>
                <Text as="strong">สิทธิขอคัดค้าน (right to object)</Text>{' '}
                คุณมีสิทธิขอคัดค้านการเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลของท่านในเวลาใดก็ได้
                เว้นแต่ว่าการเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลของท่านนั้นถูกทำขึ้นเพื่อการดำเนินงานที่จำเป็นภายใต้ประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลหรือนิติบุคคลอื่น
                หรือเพื่อการดำเนินการตามภารกิจเพื่อสาธารณประโยชน์
                และการเก็บรวบรวม ใช้
                หรือเปิดเผยข้อมูลส่วนบุคคลนั้นไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผล
              </li>
              <li>
                <Text as="strong">
                  สิทธิขอให้ลบหรือทำลายข้อมูล (right to erasure/destruction)
                </Text>{' '}
                คุณมีสิทธิขอลบหรือทำลายข้อมูลส่วนบุคคลของคุณหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวคุณได้
                หากคุณเชื่อว่าข้อมูลส่วนบุคคลของคุณถูกเก็บรวบรวม ใช้
                หรือเปิดเผยโดยไม่ชอบด้วยกฎหมายที่เกี่ยวข้อง
                หรือเห็นว่าเราหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่เกี่ยวข้องในนโยบายฉบับนี้
                หรือเมื่อคุณได้ใช้สิทธิขอถอนความยินยอมหรือใช้สิทธิขอคัดค้านตามที่แจ้งไว้ข้างต้นแล้ว
              </li>
              <li>
                <Text as="strong">
                  สิทธิขอให้ระงับการใช้ข้อมูล (right to restriction of
                  processing)
                </Text>{' '}
                คุณมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลชั่วคราวในกรณีที่เราอยู่ระหว่างตรวจสอบตามคำร้องขอใช้สิทธิขอแก้ไขข้อมูลส่วนบุคคลหรือขอคัดค้านของคุณ
                หรือกรณีอื่นใดที่เราหมดความจำเป็นและต้องลบหรือทำลายข้อมูลส่วนบุคคลของคุณตามกฎหมายที่เกี่ยวข้องแต่คุณขอให้เราระงับการใช้แทน
              </li>
              <li>
                <Text as="strong">
                  สิทธิขอให้แก้ไขข้อมูล (right to rectification)
                </Text>{' '}
                คุณมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของคุณให้ถูกต้อง เป็นปัจจุบัน
                สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
              </li>
              <li>
                <Text as="strong">
                  สิทธิร้องเรียน (right to lodge a complaint)
                </Text>{' '}
                คุณมีสิทธิร้องเรียนต่อผู้มีอำนาจตามกฎหมายที่เกี่ยวข้อง
                หากคุณเชื่อว่าการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ
                เป็นการกระทำในลักษณะที่ฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายที่เกี่ยวข้อง
              </li>
            </ol>
          </Fragment>
        ),
      },
      {
        title: 'วิธีการใช้สิทธิ',
        scrollTo: 'privacy-how-to-exercise-these-rights',
        content: (
          <Fragment>
            <Text>
              การร้องขอใช้สิทธิใด ๆ
              ก็ตามของผู้ใช้สามารถทำได้โดยร้องขอไปยังเราผ่านช่องทางการติดต่อที่เราจัดเตรียมไว้ให้ภายใต้เอกสารฉบับนี้
              การร้องขอใช้สิทธินี้สามารถใช้ได้โดยไม่เสียค่าใช้จ่ายและจะดำเนินการให้โดยเร็วที่สุดโดยเรา
            </Text>
            <Text>
              แบบฟอร์มออนไลน์สามารถทำการกรอกได้ที่
              <Link href="https://datawow.pdpaform.com" mx="5px">
                https://datawow.pdpaform.com
              </Link>
              (โปรดระบุว่าเป็นการร้องขอสำหรับเว็บไซต์ Learn PDPA)
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'การโฆษณาและการตลาด',
        scrollTo: 'privacy-marketing-and-advertisement',
        content: (
          <Fragment>
            <Text>
              เพื่อประโยชน์ในการได้รับสินค้าหรือบริการของเรา
              เราใช้ข้อมูลของคุณเพื่อวิเคราะห์และปรับปรุงสินค้าหรือบริการ
              และทำการตลาดผ่าน Google, Facebook และอื่น ๆ
              เราใช้ข้อมูลดังกล่าวเพื่อให้สินค้าหรือบริการเหมาะสมกับคุณ
              เว็บไซต์ของเราอาจแสดงโฆษณาจากบุคคลที่สามเพื่ออำนวยความสะดวกในการบริการของเรา
              บุคคลที่สามเหล่านี้อาจเข้าถึงข้อมูลส่วนบุคคลของคุณเพื่อดำเนินการเหล่านี้เท่านั้น
              และมีหน้าที่ไม่เปิดเผยหรือใช้เพื่อวัตถุประสงค์อย่างอื่น
            </Text>
            <Text>
              เราจะไม่ใช้ระบบการตัดสินใจอัตโนมัติ (automated decision-making)
              โดยปราศจากการมีบุคคลกำกับดูแล รวมถึงการทำโปรไฟล์ลิ่ง (profiling)
              ในลักษณะที่ก่อให้เกิดผลกระทบกับคุณอย่างมีนัยสำคัญ
            </Text>
            <Text>
              เราและพันธมิตรทางธุรกิจของเราอาจส่งข้อมูลทางการตลาด โฆษณา
              และข้อมูลเกี่ยวกับการส่งเสริมการขาย หรือจดหมายข่าวไปยังอีเมลของคุณ
              โดยมีวัตถุประสงค์เพื่อเสนอสิ่งที่น่าสนใจให้กับคุณ
              หากคุณไม่ต้องการรับการติดต่อสื่อสารจากเราผ่านทางอีเมลอีกต่อไป
              คุณสามารถกด &quot;ยกเลิกการติดต่อ&quot;
              ในลิงก์อีเมลหรือติดต่อมายังอีเมลของเราได้
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'เทคโนโลยีติดตามตัวบุคคล (Cookies)',
        scrollTo: 'privacy-cookies',
        content: (
          <Fragment>
            <Text>
              เพื่อเพิ่มประสบการณ์การใช้งานของคุณให้สมบูรณ์และมีประสิทธิภาพมากขึ้น
              เราใช้เทคโนโลยีติดตามตัวบุคคล(Cookies)หรือเทคโนโลยีที่คล้ายคลึงกัน
              เพื่อพัฒนาการเข้าถึงสินค้าหรือบริการ โฆษณาที่เหมาะสม
              และติดตามการใช้งานของคุณ
              เราใช้คุกกี้เพื่อระบุและติดตามผู้ใช้งานเว็บไซต์และการเข้าถึงเว็บไซต์ของเรา
              หากคุณไม่ต้องการให้มีคุกกี้ไว้ในคอมพิวเตอร์ของคุณ
              คุณสามารถตั้งค่าบราวเซอร์เพื่อปฏิเสธคุกกี้ก่อนที่จะใช้เว็บไซต์ของเราได้
            </Text>
            <Text>
              <Text as="strong">ประเภทของคุกกี้</Text>
            </Text>
            <ul>
              <li>
                <Text as="strong">
                  คุกกี้ที่มีความจำเป็นอย่างยิ่ง (Strictly Necessary Cookies):
                </Text>{' '}
                คุกกี้เหล่านี้คือคุกกี้ที่จำเป็นต้องมีเพื่อให้เว็บไซต์ทำงานได้และเป็นสิ่งจำเป็นที่ช่วยให้เราสามารถระบุตัวตนของผู้ใช้
                และการเข้าถึง เพื่อป้องกันข้อมูลส่วนบุคคลได้อย่างถูกต้อง ปลอดภัย
                นอกจากนั้นยังเป็นตัวช่วยในการจัดการคอนเทนต์ตามสิทธิที่ได้รับอย่างถูกต้อง
              </li>
              <li>
                <Text as="strong">
                  คุกกี้เพื่อการวิเคราะห์/เพื่อประสิทธิภาพ (Analytical Cookies):
                </Text>{' '}
                คุกกี้ประเภทนี้จะช่วยให้เราสามารถจดจำและจัดเก็บ Error log
                ที่เกิดขึ้นระหว่างการใช้งาน
                เพื่อปรับปรุงและแก้ไขการทำงานของเว็บไซต์ให้มีคุณภาพดีขึ้นและมีความเหมาะสมมากขึ้น
                อีกทั้งเพื่อรวบรวมข้อมูลทางสถิติเกี่ยวกับวิธีการเข้าและพฤติกรรมการเยี่ยมชมเว็บไซต์ซึ่งจะช่วยปรับปรุงการทำงานของเว็บไซต์โดยให้ผู้ใช้งานสามารถค้นหาสิ่งที่ต้องการได้อย่างง่ายดายและช่วยให้เราเข้าใจถึงความสนใจของผู้ใช้บริการ
              </li>
              <li>
                <Text as="strong">
                  คุกกี้เพื่อการทำงานของเว็บไซต์ (Functionality Cookies):
                </Text>{' '}
                คุกกี้เหล่านี้ใช้ในการจัดเก็บ Cookie
                เพื่อการปรับแต่งภาษาของการใช้งานในระบบให้สอดคล้องกับผู้ใช้
                เพื่อรองรับการเชื่อมต่อใหม่ในกรณีที่มีการถูกตัดขาด
                หรือเกิดปัญหาระหว่างใช้งาน และมีการจัดเก็บ Cookie
                เพื่อการจดจำจำนวน Interactive Function ที่เกิดขึ้นมาในระบบ
              </li>
              <li>
                <Text as="strong">
                  คุกกี้โซเชียลมีเดีย (Social Media Cookies):{' '}
                </Text>{' '}
                คุกกี้ของบุคคลที่สามจากเว็บไซต์โซเชียลมีเดีย (เช่น Facebook,
                Twitter และอื่น ๆ )
                เพื่อช่วยให้เราติดตามผู้ใช้เครือข่ายโซเชียลเมื่อพวกเขาเยี่ยมชมเว็บไซต์ของเรา
                ใช้บริการของเราหรือแบ่งปันเนื้อหาในเว็บไซต์ของเรา
                โดยใช้เครื่องมือในการติดแท็กที่จัดเตรียมไว้โดยเครือข่ายโซเชียลเหล่านั้น
                นอกจากนี้คุกกี้เหล่านี้ยังใช้สำหรับการติดตามเหตุการณ์และเพื่อวัตถุประสงค์ในการการทำโฆษณาออนไลน์ในรูปแบบของการติดตามกลุ่มเป้าหมายหรือลูกค้าที่เข้ามาในเว็บไซต์ของเราแต่ยังไม่ได้ซื้อสินค้า
                โดยข้อมูลใด ๆ
                ที่รวบรวมด้วยเครื่องมือแท็กเหล่านี้จะถูกนำไปใช้ตามนโยบายความเป็นส่วนตัวของเรา
                และเราจะไม่รวบรวมหรือแบ่งปันข้อมูลส่วนบุคคลใด ๆ
                ที่สามารถระบุตัวตนของผู้ใช้ได้ เช่น
                <br />
                <br />
                Google Analytics -
                การสร้างสถิติเกี่ยวกับวิธีที่ผู้เยี่ยมชมใช้เว็บไซต์โดยที่ไม่ระบุตัวตน
                คุกกี้เหล่านี้ใช้เพื่อแยกแยะผู้ใช้
                เราใช้คุกกี้เหล่านี้เพื่อปรับปรุงในแง่ของประสบการณ์ของผู้ใช้บนเว็บไซต์ของเราเท่านั้นและเพื่อทราบว่าเนื้อหาใดของเว็บไซต์ที่ได้รับความสนใจ
                มีการเข้าชมหรือคลิกบ่อยที่สุด
                <br />
                <br />
                Hotjar - คุกกี้ที่เก็บ ติดตามและวิเคราะห์พฤติกรรมของผู้ใช้งาน
              </li>
            </ul>
          </Fragment>
        ),
      },
      {
        title: 'การรักษาความมั่งคงปลอดภัยของข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-information-security',
        content: (
          <Fragment>
            <Text>
              เราจะรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลของคุณไว้ตามหลักการ
              การรักษาความลับ (confidentiality) ความถูกต้องครบถ้วน (integrity)
              และสภาพพร้อมใช้งาน (availability) ทั้งนี้ เพื่อป้องกันการสูญหาย
              เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข หรือเปิดเผย
              นอกจากนี้เราจะจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคล
              ซึ่งครอบคลุมถึงมาตรการป้องกันด้านการบริหารจัดการ (administrative
              safeguard) มาตรการป้องกันด้านเทคนิค (technical safeguard)
              และมาตรการป้องกันทางกายภาพ (physical safeguard)
              ในเรื่องการเข้าถึงหรือควบคุมการใช้งานข้อมูลส่วนบุคคล (access
              control) นอกจากนี้ พนักงาน ลูกจ้าง
              และผู้ให้บริการภายนอกของเรามีหน้าที่ต้องรักษาความลับของข้อมูลส่วนบุคคลของเจ้าของข้อมูล
              และต้องปฏิบัติตามมาตรฐานและนโยบายการรักษาความปลอดภัยของข้อมูลที่เคร่งครัดเมื่อมีการใช้
              ส่ง โอน หรือประมวลผลใด ๆ กับข้อมูลส่วนบุคคลของคุณ
            </Text>
            <Text>
              ในกรณีที่เราหรือคุณได้กำหนดรหัสผ่านเพื่อการเข้าใช้บริการแพลตฟอร์ม
              คุณจะต้องรับผิดชอบในการรักษารหัสผ่านดังกล่าวไว้เป็นความลับเพื่อป้องกันไม่ให้บุคคลอื่นเข้าถึงข้อมูลส่วนบุคคลของคุณโดยมิชอบ
            </Text>
          </Fragment>
        ),
      },
      {
        title: 'การแจ้งเหตุละเมิดข้อมูลส่วนบุคคล',
        scrollTo: 'privacy-data-breach',
        content: (
          <Text>
            ในกรณีที่มีเหตุละเมิดข้อมูลส่วนบุคคลของคุณเกิดขึ้น
            เราจะแจ้งให้สำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลทราบโดยไม่ชักช้าภายใน
            72 ชั่วโมง นับแต่ทราบเหตุเท่าที่สามารถกระทำได้
            ในกรณีที่การละเมิดมีความเสี่ยงสูงที่จะมีผลกระทบต่อสิทธิและเสรีภาพของคุณ
            เราจะแจ้งการละเมิดให้คุณทราบพร้อมกับแนวทางการเยียวยาโดยไม่ชักช้าผ่านช่องทางต่าง
            ๆ เช่น เว็บไซต์ ข้อความ (SMS) อีเมล โทรศัพท์ จดหมาย เป็นต้น
          </Text>
        ),
      },
      {
        title: 'การแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัว',
        scrollTo: 'privacy-changes-and-amendments',
        content: (
          <Text>
            เราขอสงวนสิทธิในการแก้ไขเปลี่ยนแปลงนโยบายนี้เป็นครั้งคราว
            เราจะเผยแพร่การเปลี่ยนแปลงดังกล่าวบนหน้าเพจนี้
            กรุณากลับเข้ามาอ่านหน้าเพจนี้เป็นระยะเพื่อให้ทราบถึงการปรับปรุงหรือการเปลี่ยนแปลงนโยบายความเป็นส่วนตัวของเรา
            สำหรับกรณีที่เป็นการเปลี่ยนแปลงในสาระสำคัญ
            เราจะแจ้งให้คุณทราบถึงการเปลี่ยนแปลงดังกล่าวโดยเร็ว
          </Text>
        ),
      },
      {
        title: 'รายละเอียดการติดต่อ',
        scrollTo: 'privacy-contacting-us',
        content: ContactingUs,
      },
    ],
  },
}
